import React from 'react';
import {useTranslation} from 'react-i18next';
import { motion } from 'framer-motion';
import { ASSETS_URL } from "../../constants";
import { fadeInLeft, fadeInRight, fadeInUp, staggerContainer, staggerItem, hoverVariants, buttonVariants } from '../../utility/framerMotionAnimations';

const BusinesNeedsSection = ({ onScrollToForm, onBoxClick }) => {
    const handleClick = (event) => {
        const valueToSelect = event.currentTarget.getAttribute("data-attr");
        onBoxClick(valueToSelect);
        onScrollToForm();
    };
    const handleCommercialVehicleLoanRedirect = () => {
        window.location.href = "/commercial-vehicle-loan";
    };
    const handleBusinessExpansionLoanRedirect = ()=>{
        window.location.href ="/business-expansion";
    }
    const handleInventoryFinancingLoanRedirect = ()=>{
        window.location.href ="/inventory-financing";
    }
    const {t}= useTranslation('homepage');
    return (
        <section className='business-needs-section mt-8'>
            <div className="section-container flex-row mobile-flex-block">
                <motion.div 
                    className="col-md-40 pr-40"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInLeft}
                >
                    <motion.div 
                        className="business-needs-title"
                        variants={fadeInUp}
                    >
                        {t('business-needs-title.line1')}<br/> {t('business-needs-title.line2')}
                    </motion.div>
                    <motion.div 
                        className="business-needs-title-mobile"
                        variants={fadeInUp}
                    >
                        {t('business-needs-title-mobile')}
                    </motion.div>
                    <motion.div 
                        className="business-needs-content mt-2"
                        variants={fadeInUp}
                        transition={{ delay: 0.2 }}
                    >
                        {t('business-needs-content')}
                    </motion.div>
                    <motion.div 
                        className="business-needs-button mt-2"
                        variants={buttonVariants}
                        initial="hidden"
                        whileInView="visible"
                        whileHover="hover"
                        whileTap="tap"
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                    >
                        <button className="btn-small btn-primary" onClick={onScrollToForm}>{t('business-needs-button')}</button>
                    </motion.div>
                    <motion.div 
                        className="business-needs-image"
                        variants={fadeInUp}
                        transition={{ delay: 0.6 }}
                    >
                        <img src={`${ASSETS_URL}images/airplane-layout.png`} alt="Get Loans for Any Business Needs"/>
                    </motion.div> 
                </motion.div>
                <motion.div 
                    className="col-md-60"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    <div className="flex-row">
                        <motion.div 
                            className="business-needs-box1" 
                            onClick={handleCommercialVehicleLoanRedirect} 
                            data-attr="Commercial Vehicle Loan"
                            variants={staggerItem}
                            whileHover={hoverVariants.hover}
                        >
                            <div className="business-needs-box-title">{t('business-needs-box-title1.line1')}<br/>{t('business-needs-box-title1.line2')}</div>
                            <div className="business-needs-box1-image">
                                <img src={`${ASSETS_URL}images/commercial-vehicle-vectors.png`} alt="Purchase a New Commercial Vehicle"/>
                            </div>
                        </motion.div>
                        <motion.div 
                            className="business-needs-box2" 
                            onClick={handleClick} 
                            data-attr="Commercial Equipment Financing"
                            variants={staggerItem}
                            whileHover={hoverVariants.hover}
                        >
                            <div className="business-needs-box-title">{t('business-needs-box-title2.line1')}<br/>{t('business-needs-box-title2.line2')}</div>
                            <div className="business-needs-box2-image">
                                <img src={`${ASSETS_URL}images/equipment-vectors.png`} alt="Equipment Financing"/>
                            </div>
                        </motion.div>
                    </div>
                    <div className="flex-row">
                        <motion.div 
                            className="business-needs-box3" 
                            onClick={handleInventoryFinancingLoanRedirect} 
                            data-attr="Inventory or Supply Chain Financing"
                            variants={staggerItem}
                            whileHover={hoverVariants.hover}
                        >
                            <div className="business-needs-box-title">{t('business-needs-box-title3.line1')}<br/>{t('business-needs-box-title3.line2')}</div>
                            <div className="business-needs-box3-image">
                                <img src={`${ASSETS_URL}images/inventory-vectors.png`} alt="Inventory Financing"/>
                            </div>
                        </motion.div>
                        <motion.div 
                            className="business-needs-box4" 
                            onClick={handleBusinessExpansionLoanRedirect} 
                            data-attr="Business Loan"
                            variants={staggerItem}
                            whileHover={hoverVariants.hover}
                        >
                            <div className="business-needs-box-title">{t('business-needs-box-title4.line1')}<br/>{t('business-needs-box-title4.line2')}</div>
                            <div className="business-needs-box4-image">
                                <img src={`${ASSETS_URL}images/buisness-expanstion-vector.png`} alt="Loan for Business Expansion"/>
                            </div>
                        </motion.div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}

export default BusinesNeedsSection;